<template>
    <div class="dokan-logical-container">
        <ul>
            <li class="dokan-logical-label-li" v-for="(level, index ) in this.badge_levels" :key="level.level_data">
                <span class="badge-level">{{ sprintf( __( 'Level %d', 'dokan' ), index + 1 ) }}</span>
                <div class="level-condition">
                    <span>{{ event.condition_text.prefix }}</span>
                    <div class="input-group">
                        <span class="input-group-text">
                            <i class="icon" :class="getBadgeEvent().input_group_icon.data"></i>
                        </span>
                        <input class="logical-number form-control" type="number" :min="index > 0 ? getMinimumLevelData(index - 1) : 1" v-on:change="setLevelData( index )" v-model.lazy="badge_levels[index].level_data">
                    </div>
                    <span v-if="event.condition_text.suffix">{{event.condition_text.suffix}}</span>
                    <i class="remove-level" @click.prevent="removeLevel(index)" v-show="( index > 0 )" :title="__('Remove badge level', 'dokan')"></i>
                </div>
            </li>
        </ul>
        <div>
            <button @click.prevent="addLevel" :disabled="this.addNewButtonDisabled" class="button button-secondary">+ {{ __('Add', 'dokan') }}</button>
        </div>
    </div>
</template>

<script>
import defaultBadgeLevelData from '../../../BadgeLevel.json';

export default {
    name: 'LogicalComponent',

    props: {
        event: {
            type: Object,
            default () {
                return this.getDefaultBadgeLevels();
            },
        },
    },

    data () {
        return {
            conditions: [
                {
                    label: this.__('More than', 'dokan'),
                    value: '>',
                },
            ],
            badge_levels: this.getLevels(),
            addNewButtonDisabled: false,
        }
    },

    inject: ['setBadgeLevels', 'getBadgeLevels', 'getBadgeEvent'],

    created () {
        this.$watch('badge_levels', (newLevels) => {
            this.setBadgeLevels( this.badge_levels );
        });
    },

    updated () {
        this.disableAddNewButton();
    },

    mounted() {
        this.disableAddNewButton();
    },

    activated() {
        // keep-alive
        // called on initial mount
        // and every time it is re-inserted from the cache
        this.setBadgeLevels( this.badge_levels );
    },

    deactivated() {
        // keep-alive
        // called when removed from the DOM into the cache
        // and also when unmounted
    },

    methods: {
        getLevels() {
            if ( ! this.getBadgeLevels().length ) {
                return this.getDefaultBadgeLevels();
            }
            return this.getBadgeLevels();
        },

        getDefaultBadgeLevels() {
            defaultBadgeLevelData.level_condition = '>';
            defaultBadgeLevelData.level_data = 10;
            return [
                Object.assign( {}, defaultBadgeLevelData ),
            ]
        },

        addLevel() {
            const length = this.badge_levels.length - 1;
            let data = Object.assign( {}, this.badge_levels[length] );
            data.id = 0;
            data.level_data = parseInt( data.level_data ) + 1;
            this.badge_levels.push( data );
        },

        removeLevel(index) {
            this.badge_levels.splice( index, 1 );
        },

        setLevelData( index ) {
            // validate index data is a valid int
            const current_value = parseInt( this.badge_levels[index].level_data );
            if ( current_value < 0 || isNaN( current_value ) ) {
                this.badge_levels[index].level_data = 1;
            }
            // sort data
            this.badge_levels.sort( this.sortLevelData );
            const length = this.badge_levels.length;

            // after sort increase value by 1
            for ( let index = 0; index < length; index++ ) {
                const current_value = parseInt( this.badge_levels[index].level_data );
                if ( 0 === index ) {
                    this.badge_levels[0].level_data = current_value > 0 ? current_value:  1;
                    continue;
                }
                const previous_data = parseInt( this.badge_levels[index-1].level_data );
                const min_value = previous_data + 1;
                this.badge_levels[index].level_data = current_value <= min_value ? min_value : current_value;
            }
        },

        setConditionData() {
            const length = this.badge_levels.length;
            if ( length <= 1 ) {
                return;
            }
            const condition = this.badge_levels[0].level_condition;
            for ( let index = 1; index < length; index++ ) {
                this.badge_levels[index].level_condition = condition;
            }
        },

        sortLevelData( a, b ) {
            const value1 = parseInt( a.level_data );
            const value2 = parseInt( b.level_data );
            if ( value1 < value2 ) {
                return -1;
            }
            if ( value1 > value2 ) {
                return 1;
            }
            return 0;
        },

        getMinimumLevelData( previous_index ) {
            const data = this.badge_levels[previous_index];
            return parseInt( data.level_data ) + 1;
        },

        disableAddNewButton() {
            if ( ! this.badge_levels.length ) {
                return;
            }
            const length = this.badge_levels.length - 1;
            const data = this.badge_levels[length];
            this.addNewButtonDisabled = null === data.level_condition || ! data.level_condition.length || ! data.level_data;
        },
    },
}
</script>
<style lang="less" scoped>
.dokan-logical-container {
    .dokan-logical-label-li {
        margin-bottom: 20px;
    }

    .badge-level {
        background: #B9B9B9;
        border-radius: 1rem;
        padding: 0.3rem 1rem;
        vertical-align: middle;
        display: inline-block;
        margin-bottom: 1rem;
        line-height: 16px;
        letter-spacing: 0.08px;
        color: #FFFFFF;
        font-size: 0.75rem;
        font-weight: 600;
    }

    .remove-level {
        background: url('../../../../images/others/close.svg');
        width: 14px;
        height: 14px;
        line-height: 17px;
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
    }

    .logical-select,
    .logical-number {
        border: 1px solid #e2e2e2;
        border-radius: 3px;
        height: 42px ;
        font-size: 15px;
        width: 145px;
    }

    .level-condition {
        display: flex;
        align-items: center;
        gap: 1rem;
        font-size: 0.875rem;


        @media (max-width: 767px) {
            flex-flow: row wrap;
            grid-column-gap: 15px;
            grid-row-gap: 25px;
            margin-bottom: 40px;
        }
    }
}
</style>
